import {DataSourceFootnote} from "./DataSourceFootnote";

interface XeroPnlCfoQuestionsProps {
    questions: string[];
    generatedAt?: string;
    showFootnote?: boolean;
}

export function XeroPnlCfoQuestions({questions, generatedAt, showFootnote = true}: XeroPnlCfoQuestionsProps) {
    if (!questions.length) return null;

    return (
        <div>
            <h3 className="text-sm font-bold uppercase tracking-[2px] text-[#209DB3] mb-3">
                Questions for CFO Review
            </h3>
            <ol className="space-y-2.5">
                {questions.map((q, i) => (
                    <li key={i} className="flex items-start gap-3 rounded-xl border bg-white p-3.5 text-sm leading-relaxed">
                        <span className="shrink-0 flex items-center justify-center w-6 h-6 rounded-full bg-[#209DB3] text-white text-xs font-bold">
                            {i + 1}
                        </span>
                        {q}
                    </li>
                ))}
            </ol>
            {showFootnote && <DataSourceFootnote generatedAt={generatedAt} />}
        </div>
    );
}
